/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';
import AuthorsIcon from 'icons/AuthorsIcon';

const messages = defineMessages({
  title: {id: 'navigation.instructional-materials.authors'},
});

const AuthorsItem = () => (
  <RouteLinkItem
    iconBefore={AuthorsIcon}
    route="midas/instructional-materials/authors"
    title={messages.title}
  />
);

export default AuthorsItem;
